export default "__VITE_ASSET__DLN09WWq__"